import { ValuableModel } from '../../models/ValuableModel'

export class SchemaUndefinedModel extends ValuableModel {}

declare global {
  export interface RehajeViewModels {
    'Schema.Undefined': SchemaUndefinedModel
  }
}
